/* Fichas de serie de Needle: glosario de las tablas comparativas. GENERADO por scripts/lab/ficha_serie.py. */
(function(){
  // El "?" abre un globo que flota sobre la pagina, porque dentro de la tabla deslizable quedaria
  // cortado. Toque en celular, mouse encima en computador.
  var globo = null, abierto = null;
  var conMouse = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  var cerrarGlos = function(){
    if(globo){ globo.hidden = true; }
    if(abierto){ abierto.setAttribute('aria-expanded', 'false'); abierto = null; }
  };
  var abrirGlos = function(b){
    if(!globo){
      globo = document.createElement('div');
      globo.className = 'glos-globo'; globo.id = 'glos-globo'; globo.setAttribute('role', 'tooltip');
      document.body.appendChild(globo);
    }
    globo.textContent = b.getAttribute('data-glos');
    globo.hidden = false;
    var r = b.getBoundingClientRect(), w = Math.min(280, window.innerWidth - 24);
    globo.style.width = w + 'px';
    globo.style.left = Math.min(Math.max(12, r.left - 8), window.innerWidth - w - 12) + 'px';
    var y = r.bottom + 8;
    globo.style.top = y + 'px';
    if(y + globo.offsetHeight > window.innerHeight - 8){ globo.style.top = Math.max(8, r.top - globo.offsetHeight - 8) + 'px'; }
    b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-describedby', 'glos-globo');
    abierto = b;
  };
  document.addEventListener('click', function(ev){
    var b = ev.target.closest && ev.target.closest('.ficha .glos');
    if(b){
      ev.preventDefault();
      if(abierto === b){ if(!conMouse){ cerrarGlos(); } }
      else { cerrarGlos(); abrirGlos(b); }
      return;
    }
    if(abierto){ cerrarGlos(); }
  });
  if(conMouse){
    document.addEventListener('mouseover', function(ev){
      var b = ev.target.closest && ev.target.closest('.ficha .glos');
      if(b && b !== abierto){ cerrarGlos(); abrirGlos(b); }
    });
    document.addEventListener('mouseout', function(ev){
      var b = ev.target.closest && ev.target.closest('.ficha .glos');
      if(b && b === abierto && !b.contains(ev.relatedTarget)){ cerrarGlos(); }
    });
  }
  document.addEventListener('keydown', function(ev){ if(ev.key === 'Escape'){ cerrarGlos(); } });
  window.addEventListener('scroll', cerrarGlos, { passive: true });
  document.addEventListener('scroll', function(ev){
    if(ev.target && ev.target.classList && ev.target.classList.contains('comp-scroll')){ cerrarGlos(); }
  }, true);
})();
